(function () {
  const clamp = (n, min, max) => Math.min(max, Math.max(min, n));

  const fmtInt = (n) =>
    new Intl.NumberFormat(undefined, { maximumFractionDigits: 0 }).format(n);

  const fmtMoney = (n, currency) =>
    new Intl.NumberFormat(undefined, {
      style: "currency",
      currency,
      maximumFractionDigits: 0,
    }).format(n);

  const fmtPercent = (n) =>
    new Intl.NumberFormat(undefined, {
      style: "percent",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(n);

  function init(root) {
    if (!root || root.__crocalcInit) return;
    root.__crocalcInit = true;

    const ds = root.dataset;

    const defaults = {
      users: parseFloat(ds.defaultUsers || "100000"),
      cr: parseFloat(ds.defaultCr || "2.5"),
      aov: parseFloat(ds.defaultAov || "70"),
      newCr: parseFloat(ds.defaultNewCr || "3.5"),
      newAov: parseFloat(ds.defaultNewAov || "75"),
      currency: (ds.defaultCurrency || "USD").toUpperCase(),
    };

    const currencySel = root.querySelector("[data-crocalc-currency]");
    const resetBtn = root.querySelector("[data-crocalc-reset]");

    const out = (key) => root.querySelector(`[data-crocalc-out="${key}"]`);
    const range = (key) => root.querySelector(`[data-crocalc-range="${key}"]`);
    const num = (key) => root.querySelector(`[data-crocalc-num="${key}"]`);

    const keys = ["users", "cr", "aov", "newCr", "newAov"];

    function setDefaults() {
      keys.forEach((k) => {
        if (range(k)) range(k).value = defaults[k];
        if (num(k)) num(k).value = defaults[k];
      });
      if (currencySel) currencySel.value = defaults.currency;
      calc();
    }

    function calc() {
      const currency = currencySel ? currencySel.value : defaults.currency;

      const users = parseFloat(num("users")?.value) || 0;

      const cr = (parseFloat(num("cr")?.value) || 0) / 100;
      const aov = parseFloat(num("aov")?.value) || 0;

      const newCr = (parseFloat(num("newCr")?.value) || 0) / 100;
      const newAov = parseFloat(num("newAov")?.value) || 0;

      const curOrders = users * cr;
      const curRev = curOrders * aov;

      const newOrders = users * newCr;
      const newRev = newOrders * newAov;

      const addRev = newRev - curRev;
      const pctInc = curRev > 0 ? addRev / curRev : 0;

      if (out("curConv")) out("curConv").textContent = fmtInt(Math.round(curOrders));
      if (out("curRev")) out("curRev").textContent = fmtMoney(Math.round(curRev), currency);

      if (out("newConv")) out("newConv").textContent = fmtInt(Math.round(newOrders));
      if (out("newRev")) out("newRev").textContent = fmtMoney(Math.round(newRev), currency);

      if (out("addRev")) out("addRev").textContent = fmtMoney(Math.round(addRev), currency);

      const newCrText = (newCr * 100).toFixed(1).replace(/\.0$/, "") + "%";
      if (out("newCrOut")) out("newCrOut").textContent = newCrText;

      if (out("newAovOut")) out("newAovOut").textContent = fmtMoney(Math.round(newAov), currency);

      if (out("pctInc")) out("pctInc").textContent = fmtPercent(pctInc);

      if (out("pctIncBadge")) {
        const badge = out("pctIncBadge");
        badge.textContent = `${(pctInc * 100).toFixed(0)}% uplift`;
      }
    }

    function syncFromNum(k) {
      const n = num(k);
      const r = range(k);
      if (!n || !r) return;

      const min = parseFloat(n.min || r.min);
      const max = parseFloat(n.max || r.max);
      const v = clamp(parseFloat(n.value || r.value), min, max);

      n.value = v;
      r.value = v;
      calc();
    }

    function syncFromRange(k) {
      const n = num(k);
      const r = range(k);
      if (!n || !r) return;

      n.value = r.value;
      calc();
    }

    keys.forEach((k) => {
      const n = num(k);
      const r = range(k);
      if (n) n.addEventListener("input", () => syncFromNum(k));
      if (r) r.addEventListener("input", () => syncFromRange(k));
    });

    root.addEventListener("click", (e) => {
      const btn = e.target.closest("[data-crocalc-minus],[data-crocalc-plus]");
      if (!btn) return;

      const wrap = btn.closest("[data-crocalc-stepper]");
      if (!wrap) return;

      const k = wrap.getAttribute("data-crocalc-stepper");
      const n = num(k);
      if (!n) return;

      const step = parseFloat(n.step || "1");
      const min = parseFloat(n.min);
      const max = parseFloat(n.max);
      const cur = parseFloat(n.value) || 0;

      const next = btn.hasAttribute("data-crocalc-plus") ? cur + step : cur - step;
      n.value = clamp(next, min, max);

      syncFromNum(k);
    });

    if (currencySel) currencySel.addEventListener("change", calc);
    if (resetBtn) resetBtn.addEventListener("click", setDefaults);

    // init values
    setDefaults();
  }

  function boot() {
    document.querySelectorAll("[data-crocalc]").forEach(init);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  document.addEventListener("shopify:section:load", function (e) {
    const root = e.target && e.target.querySelector && e.target.querySelector("[data-crocalc]");
    if (root) init(root);
  });
})();
